import { render, staticRenderFns } from "./ForeignExchangeAccount.vue?vue&type=template&id=5a45742b&scoped=true"
import script from "./ForeignExchangeAccount.vue?vue&type=script&lang=js"
export * from "./ForeignExchangeAccount.vue?vue&type=script&lang=js"
import style0 from "./ForeignExchangeAccount.vue?vue&type=style&index=0&id=5a45742b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a45742b",
  null
  
)

export default component.exports